import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';



@Component({
  selector: 'printopbillfooterview',
  templateUrl: './printopbillfooterview.component.html',
  styleUrls: ['./printopbillfooterview.component.scss']
})

export class  PrintopbillfooterviewComponent implements OnInit {
  
  public Date: Date;

 

 
  constructor(private route: ActivatedRoute, private router: Router,) { }


  ngOnInit() {

    this.Date = new Date();
  }
  

 
 
 


 
}
